import { SpeedBumpOverlay } from '../../common/SpeedBumpOverlay/SpeedBumpOverlay';
import '../../scss/_dontExtract_/mcom/main.scss';
import template from '../../templates/mcom/SpeedBumpOverlay/SpeedBumpOverlay';
import { postFor } from '../PostBuilder';

export default class extends SpeedBumpOverlay {
  constructor(options = {}) {
    options.template = template;
    options.postFor = postFor;
    super(options);
  }
}
